import fetch from 'cross-fetch'
import Axios from 'axios';
import { browserHistory } from 'react-router';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../utils/apiUtils';
var request = require('request');

export const RECEIVE_FREQUENCY='RECEIVE_FREQUENCY'
export const DELETE_FREQUENCY='DELETE_FREQUENCY'
export const GET_FREQUENCY='GET_FREQUENCY'
export const CREATE_FREQUENCY='CREATE_FREQUENCY'
export const UPDATE_FREQUENCY='UPDATE_FREQUENCY'
export const CHECK_FREQUENCY='CHECK_FREQUENCY'

// const header={"device-type": "AML9327483","token-id":"aGlyZW5AbWFqZXN0aWNzZXJ2aWNlc2dyb3VwLmNvbS5hdTpoaXJlbjoyNTEx"};

/* fetch frequency function */
function fetchFrequency() {
  return async dispatch => {
      return await getRequest({ url: '/api/managed_occurrences'})
      .then(response => {
          //console.log(response)
        if(response.data.result.length>0)
        {
          dispatch(requestFrequency(response.data.result))
        }
        else
        {
          dispatch(requestFrequency([]))
        }
       
      })
      .catch(error => {
        if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
      });
  }
}

/* delete frequency */

function deleteFrequencyId(id) {
    console.log(id);
    return async dispatch => {
        return await deleteRequest({ url: '/api/managed_occurrences/'+id})
        .then(response => {
            console.log(response)
            dispatch(deleteFrequencyData(response.data))
         
        })
        .catch(error => {
          if (error.response) 
          {
            if(error.response.status===403)
            {
              browserHistory.push('/');
              window.location.reload(); 
            }
            else
            {
              console.log(error);
            }
          }
        });
    }
  }

  /* get frequency data */

  function fetchFrequencyById(id) {
    return async dispatch => {
        return await getRequest({ url: '/api/managed_occurrences/'+id})
        .then(response => {
            console.log(response);
          if(response.data.result.length>0)
          {
            dispatch(getFrequencyData(response.data.result))
          }
          else
          {
            dispatch(getFrequencyData([]))
          }
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function createFrequency(post) {
    return async dispatch => {
        return await postRequest({ url: '/api/managed_occurrences', payload: {name:post[0].name,description:post[0].description,occur_frequency:post[0].occur_frequency,frequency_count:post[0].frequency_count,occurrence_type:post[0].occurrence_type, status:post[0].status}})
        .then(response => {
            dispatch(createNewFrequency(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function updateFrequency(post) {
    return async dispatch => {
        return await putRequest({ url: '/api/managed_occurrences', payload: {name:post[0].name,description:post[0].description,occur_frequency:post[0].occur_frequency,occur_schedule_config:"",status:post[0].status,id:post[0].id,frequency_count:post[0].frequency_count,occurrence_type:post[0].occurrence_type}})
        .then(response => {
            dispatch(editFrequency(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }


function requestFrequency(response) {
  return {
    type: RECEIVE_FREQUENCY,
    frequency_data: response
  }
}

function deleteFrequencyData(response) {
    return {
      type: DELETE_FREQUENCY,
      frequency_delete_data: response
    }
  }

  function getFrequencyData(response) {
    return {
      type: GET_FREQUENCY,
      frequency_data_by_id: response
    }
  }

  function createNewFrequency(response) {
    return {
      type: CREATE_FREQUENCY,
      frequency_create_response: response
    }
  }

  function editFrequency(response) {
    return {
      type: UPDATE_FREQUENCY,
      frequency_create_response: response
    }
  }


export function fetchFrequencyList() {
  return (dispatch) => {
      return dispatch(fetchFrequency())
  }
}

export function deleteFrequency(id) {
    return (dispatch) => {
        return dispatch(deleteFrequencyId(id))
    }
  }

  export function getFrequencyByid(id) {
     return (dispatch) => {
         return dispatch(fetchFrequencyById(id))
     }
   }

   export function addNewFrequency(post) {
    return (dispatch) => {
        return dispatch(createFrequency(post))
    }
  }

  export function editFrequencyData(post) {
    return (dispatch) => {
        return dispatch(updateFrequency(post))
    }
  }

  function requestCheckFrequency(post) {
    return async dispatch => {
        return await postRequest({ url: '/api/check_exist_frequency', payload: {frequency_name:post}})
        .then(response => {
            dispatch(checkFrequency(response.data))
        })
        .catch(error => {
          if (error.response) 
						{
							if(error.response.status===403)
							{
								browserHistory.push('/');
								window.location.reload(); 
							}
							else
							{
								console.log(error);
							}
						}
        });
    }
  }

  function checkFrequency(response) {
    return {
      type: CHECK_FREQUENCY,
      check_frequency: response
    }
  }

  export function checkExistFrequency(post) {
    return (dispatch) => {
        return dispatch(requestCheckFrequency(post))
    }
  }




// WEBPACK FOOTER //
// ./src/shared/actions/frequency_action.js